import { render, staticRenderFns } from "./GameFinishDialog.vue?vue&type=template&id=0602dd18&scoped=true"
import script from "./GameFinishDialog.vue?vue&type=script&lang=js"
export * from "./GameFinishDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0602dd18",
  null
  
)

export default component.exports